import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

// so the missing key will be obvious in the UI
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return params.key;
  }
}
